import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { handleInitialHashScroll } from '@/utils/scrollToAnchor';

/**
 * Hook that handles scrolling to hash anchors on initial page load
 * and after route changes.
 */
export const useHashScroll = () => {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChangeComplete = (url: string) => {
      const hash = url.split('#')[1];
      if (hash) {
        handleInitialHashScroll();
      }
    };

    handleInitialHashScroll();

    router.events.on('routeChangeComplete', handleRouteChangeComplete);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChangeComplete);
    };
  }, [router.events]);
};
